import { atom } from 'jotai';
import type { ChartImageExporter, OutputFormat } from './types';

interface ExportImageState {
  open: boolean;
  exporter: ChartImageExporter | null;
  chartLabel: string;
  filenamePrefix: string;
  supportedFormats: OutputFormat[];
}

const DEFAULT_STATE: ExportImageState = {
  open: false,
  exporter: null,
  chartLabel: '',
  filenamePrefix: 'chart',
  supportedFormats: ['png'],
};

export const exportImageStateAtom = atom<ExportImageState>(DEFAULT_STATE);

export const openExportImageAtom = atom(
  null,
  (
    _get,
    set,
    payload: {
      exporter: ChartImageExporter;
      chartLabel: string;
      filenamePrefix: string;
      supportedFormats?: OutputFormat[];
    }
  ) => {
    set(exportImageStateAtom, {
      open: true,
      exporter: payload.exporter,
      chartLabel: payload.chartLabel,
      filenamePrefix: payload.filenamePrefix,
      supportedFormats:
        payload.supportedFormats && payload.supportedFormats.length > 0
          ? payload.supportedFormats
          : ['png'],
    });
  }
);

export const closeExportImageAtom = atom(null, (_get, set) => {
  set(exportImageStateAtom, DEFAULT_STATE);
});
